module.exports = __webpack_public_path__ + "img/1572071597.bfcc02fe.jpg";